export const PURCHASE = 'purchase';
